
    var riot = require('riot')
    //src: starling/src/tags/modal-import/import-preview-card.html
riot.tag2('import-preview-card',
  '<div class="preview-card_title" title="{getTitleField()}">{getTitle()}</div> <div if="{getSummary()}" class="preview-card_summary" title="{getSummaryField()}">{getSummary()}</div> <div if="{getAttributes().length}" class="preview-card_attributes"> <div class="preview-card_attribute" each="{attr in getAttributes()}"> <span class="preview-card_attribute-key">{attr.key}</span> <span class="preview-card_attribute-value" if="{showAttributeValue()}">{attr.value}</span> </div> </div> <import-preview-card-parts field="{getTitleField()}" if="{this.hasParts()}">',
  '',
  'class="{this.hasParts() ? \'has-parts\' : \'\'}"', function(opts) {
'use strict';

var _this = this;

var _importUi = require('lib/import-ui');

this.instance = opts.instance;

this.getTitleField = function () {
  return _this.instance.titleField;
};

this.getSummaryField = function () {
  return _this.instance.summaryField;
};

this.getTitle = function () {
  if (_importUi.importUI.showFieldInCardOption) {
    return _this.instance.title;
  }
  if (_importUi.importUI.showFieldsInPreview) {
    return _this.getTitleField();
  }
  return _this.instance.title;
};

this.getSummary = function () {
  if (_importUi.importUI.showFieldInCardOption) {
    return _this.instance.summary;
  }
  if (_importUi.importUI.showFieldsInPreview) {
    return _this.getSummaryField();
  }
  return _this.instance.summary;
};

this.getAttributes = function () {
  return _this.instance.attributes;
};

this.showAttributeValue = function () {
  return _importUi.importUI.showFieldInCardOption;
};

this.hasParts = function () {
  if (_this.instance.partFields.length) return true;
  return false;
};

this.getParts = function () {
  return _importUi.importUI.getCards(_this.instance.partFields);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('import-preview-card')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-import/import-preview-card.html
// module id = 758
// module chunks = 0